import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Paper
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { investorApi } from '../../../api/api';
import { useSelector } from 'react-redux';
import GradientButton from '../../common/GradiantButton';

const EditVillaDetails = () => {
  const location = useLocation();
  const theme = useSelector((data) => data.themeValue.colors);
  const propertyDataArray = location.state?.propertyData;
  const rawData = propertyDataArray?.[0];
  const [formValues, setFormValues] = useState(() => {
    if (!rawData) {
      return {
        Address: '',
        AdvancePercentage: '',
        City: '',
        AgeOfBuilding: '',
        Balcony: '',
        Bathrooms: '',
        Bedrooms: '',
        LandAreaInSqFt: '',
        NoOfFloors: '',
        ParkingAvailable: '',
        ParkingType: '',
        PowerBackUp: '',
        WaterSupply: '',
        Facing: '',
        GeoLocation: '',
        MarketPrice: '',
        Pid: '',
        PropertyName: '',
        PropertyType: '',
        SizeInSqFt: '',
        SqFtPrice: '',
        Status: '',
      };
    }

    const extra = rawData.ExtraData || {};

    return {
      Address: rawData.Address || '',
      AdvancePercentage: rawData.AdvancePercentage || '',
      City: rawData.City || '',
      AgeOfBuilding: extra.AgeOfBuilding || '',
      Balcony: extra.Balcony || '',
      Bathrooms: extra.Bathrooms || '',
      Bedrooms: extra.Bedrooms || '',
      LandAreaInSqFt: extra.LandAreaInSqFt || '',
      NoOfFloors: extra.NoOfFloors || '',
      ParkingAvailable: extra.ParkingAvailable || '',
      ParkingType: extra.ParkingType || '',
      PowerBackUp: extra.PowerBackUp || '',
      WaterSupply: extra.WaterSupply || '',
      Facing: rawData.Facing || '',
      GeoLocation: rawData.GeoLocation || '',
      MarketPrice: rawData.MarketPrice || '',
      Pid: rawData.Pid || '',
      PropertyName: rawData.PropertyName || '',
      PropertyType: rawData.PropertyType || '',
      SizeInSqFt: rawData.SizeInSqFt || '',
      SqFtPrice: rawData.SqFtPrice || '',
      Status: rawData.Status || '',
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

    const handleSubmit = async (e) => {
  e.preventDefault();

  // Convert to backend expected format
 const payload = {
  Pid: formValues.Pid,
  PropertyName: formValues.PropertyName,
  PropertyType: formValues.PropertyType,
  Address: formValues.Address,
  City: formValues.City,
  GeoLocation: formValues.GeoLocation,
  SizeInSqFt: parseFloat(formValues.SizeInSqFt || 0),
  SqFtPrice: parseFloat(formValues.SqFtPrice || 0),
 OriginalPropertyValue: parseFloat(formValues.OriginalPropertyValue || 0),
  AdvancePercentage: parseFloat(formValues.AdvancePercentage || 0),
  Facing: formValues.Facing,
  Status: formValues.Status || "pending",
  ExtraData: {
    AgeOfBuilding: formValues.AgeOfBuilding,
    Balcony: parseInt(formValues.Balcony || 0),
    Bathrooms: parseInt(formValues.Bathrooms || 0),
    Bedrooms: parseInt(formValues.Bedrooms || 0),
    LandAreaInSqFt: parseFloat(formValues.LandAreaInSqFt || 0),
    NoOfFloors: parseInt(formValues.NoOfFloors || 0),
    ParkingAvailable: formValues.ParkingAvailable,
    ParkingType: formValues.ParkingType,
    PowerBackUp: formValues.PowerBackUp,
    WaterSupply: formValues.WaterSupply
  }
};

  try {
    const response = await investorApi.villaDetailsChange(payload);
    alert("Update successful");
  } catch (error) {
    alert(error)
    console.error("Error updating villa:", error);
  }
};


  return (
    <Paper elevation={3} sx={{ padding: 4, margin: 4 ,backgroundColor:theme.background}}>
      <Typography variant="h5" gutterBottom sx={{color:theme.text}}>Edit Villa Details</Typography>
      <Box component="form" >
        <Grid container spacing={2}>
          {/* Property Info */}
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Property Name" name="PropertyName" value={formValues.PropertyName} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}
            />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Address" name="Address" value={formValues.Address} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="City" name="City" value={formValues.City} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          {/* <Grid xs={12} sm={6} sx={{width:"40%"}}>
            <TextField fullWidth label="Geo Location" name="GeoLocation" value={formValues.GeoLocation} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid> */}

          {/* Building Details */}
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Age of Building" name="AgeOfBuilding" value={formValues.AgeOfBuilding} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Bedrooms" name="Bedrooms" value={formValues.Bedrooms} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Bathrooms" name="Bathrooms" value={formValues.Bathrooms} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Balcony" name="Balcony" value={formValues.Balcony} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="No. of Floors" name="NoOfFloors" value={formValues.NoOfFloors} onChange={handleChange} 
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}/>
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Facing" name="Facing" value={formValues.Facing} onChange={handleChange} 
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}/>
          </Grid>

          {/* Area & Pricing */}
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Land Area (sq ft)" name="LandAreaInSqFt" value={formValues.LandAreaInSqFt} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Size (sq ft)" name="SizeInSqFt" value={formValues.SizeInSqFt} onChange={handleChange} 
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}/>
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Market Price" name="MarketPrice" value={formValues.MarketPrice} onChange={handleChange} disabled 
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}/>
          </Grid>
          {/* <Grid xs={12} sm={6} sx={{width:"40%"}}>
            <TextField fullWidth label="SqFt Price" name="SqFtPrice" value={formValues.SqFtPrice || ''} onChange={handleChange} />
          </Grid> */}

          {/* Utilities */}
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Water Supply" name="WaterSupply" value={formValues.WaterSupply} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField fullWidth label="Power Backup" name="PowerBackUp" value={formValues.PowerBackUp} onChange={handleChange}
             sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }} />
          </Grid>
          <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
            <TextField
              select
              fullWidth
              label="Parking Available"
              name="ParkingAvailable"
              value={formValues.ParkingAvailable}
              onChange={handleChange}
               sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.text, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.text, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.text, 
                },
              },
            }}
            >
              <MenuItem value="yes" >Yes</MenuItem>
              <MenuItem value="no" >No</MenuItem>
            </TextField>
          </Grid>

          {formValues.ParkingAvailable === 'yes' && (
            <Grid xs={12} sm={6} sx={{width:{md:"47%",xs:"95%"}}}>
              <TextField
                select
                fullWidth
                label="Parking Type"
                name="ParkingType"
                value={formValues.ParkingType}
                onChange={handleChange}
                 sx={{
              // mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}
              >
                <MenuItem value="bike" >Bike</MenuItem>
                <MenuItem value="car" >Car</MenuItem>
                <MenuItem value="both" >Both</MenuItem>
              </TextField>
            </Grid>
          )}  
        </Grid>
          {/* Submit Button */}
          <Grid xs={12} sx={{marginTop:"20px"}}>
            <GradientButton  text='Save Changes'
            width='20%'
            onClick={handleSubmit}/>
           
          </Grid>
      </Box>
    </Paper>
  );
};

export default EditVillaDetails;